import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrecioReferenciaService {

  constructor() { }

  GetPreciosReferencia() {
    return [
      { value: "99", label: "Último Precio de Costo" },
      { value: "1", label: "Lista precio 1" },
      { value: "2", label: "Lista precio 2" },
      { value: "3", label: "Lista precio 3" },
      { value: "4", label: "Lista precio 4" },
      { value: "5", label: "Lista precio 5" },
    ];
  }
}
